<template>
  <div id="showtable">
    <!-- RB -->
    <template v-if="(Object.keys(sortedRBEventList).length > 0)">
      <todayHeader :marketType="market.inPlayMarket.key" @updateMethod="showMarketMatches"></todayHeader>
      <template v-if="showRBhideAll">
        <template v-for="(eventObj, eventObjKey) in sortedRBEventList">
          <!-- League Capt -->
          <div class="list-card-wrap v-scroll-item relative-position sticky-wrap" style="height: 38px !important; top: 73.5px;">
            <div class="list-card-inner">
              <div class="c-match-league match-tpl2-bg"
                :class="{ 'match-tpl2': !showRBLgeEve[eventObjKey].hide, 'leagues-pack': showRBLgeEve[eventObjKey].hide }" @click="showLeg(eventObjKey, true)">
                <div class="tr-match-head">
                  <div class="leagues-wrap" :style="{ width:  widthColumn[2] + 'px !important' }">
                    <i size="14px" class="icon-arrow q-icon c-icon"></i>
                    <div class="league-icon-wrap">
                      <!-- <img data-team="undefined" data-csid="undefined" src="https://image.gredfged.com/group1/M00/18/2E/CgURtmOoQZGAH4WgAAAg5Xi2k74855.png" style="opacity: 1;"> -->
                    </div>
                    <div class="ellipsis-wrap">
                      <div class="absolute-full">
                        <span class="ellipsis allow-user-select" :title="eventObj[0].lgecapt" v-html="eventObj[0].lgecapt"></span>
                        <span class="league-match-count">{{ eventObj.length }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="play-name vrow col" v-show="!showRBLgeEve[eventObjKey].hide"> -->
                  <div class="play-name vrow col">
                    <template v-show="!showLgeEve[eventObjKey].hide">
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.H/H'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.H/D'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.H/A'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.D/H'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.D/D'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.D/A'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.A/H'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.A/D'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.A/A'] }}</div>
                    </template>
                  </div>
                  <div class="yb-flex-center" style="width: 42px !important;">
                    <div class="icon-wrap m-star-wrap-league"  @click="favouritelgeve(eventObj[0].lgeid, $event, '0', eventObj)">
                      <i class="icon-star q-icon c-icon"  :class="{ active: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- League Events -->
          <!-- <template v-if="!sortedRBEventList[eventObjKey].hide"> -->
          <template v-if="!showRBLgeEve[eventObjKey].hide">
            <template v-for="(event, eventKey) in eventObj">
              <div class="list-card-wrap v-scroll-item relative-position" style="height: 111px !important;">
                <div class="list-card-inner">
                  <div class="c-match-card relative-position" style="height: 111px !important">
                    <div class="c-match-item tpl-2 csid-1">
                      <div class="process-col yb-flex-center">
                        <sportTime :event="event"></sportTime>
                      </div>
                      <div class="match-handicap-item-wrap">
                        <div class="match-handicap-item">
                          <sportTeam :event="event" :issc="true" classes="none" :plyType="ftPlyType" :isRB="true"  :widthL=" widthColumn[0]"></sportTeam>
                          <div class="c-match-handicap" :id="'cmatch'+event.eveid">
                            <div class="vrow no-wrap">
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'hh'" :plyType="playtype" :betType="rbbettype" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'hd'" :plyType="playtype" :betType="rbbettype" :decimalNumber="0" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'ha'" :plyType="playtype" :betType="rbbettype" :decimalNumber="0" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'dh'" :plyType="playtype" :betType="rbbettype" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'dd'" :plyType="playtype" :betType="rbbettype" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'da'" :plyType="playtype" :betType="rbbettype" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'ah'" :plyType="playtype" :betType="rbbettype" :decimalNumber="0" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'ad'" :plyType="playtype" :betType="rbbettype" :decimalNumber="0" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'aa'" :plyType="playtype" :betType="rbbettype" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="score-more" style="width: 100%;">
                              <div class="mfo"></div>
                            </div>
                          </div>
                          <div class="media-col">
                            <div class="media-col-wrap">
                              <div class="icon-wrap after_tpl0 relative-position" :class="{ active: (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }">
                                <div class="v-icon switch-icon" @click="enterAllBet(event,1)" :class="{ active:  (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }" :title="sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']"></div>
                              </div>
                              <div class="yb-flex-center"></div>
                              <div data-v-5a29cfce="" class="icon-wrap relative-position" v-if="tvIconFlag && event.ch>0" :class="{ active: livetvEveid== event.eveid}"> 
                                <div data-v-5a29cfce="" class="v-icon video-icon"  @click="enterAllBet(event,2)" :class="{ active: livetvEveid== event.eveid}" :title="sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </template> <!-- END sortedRBEventList -->
      </template>
    </template>

    <!-- Today/Early -->
    <template v-if="(Object.keys(sortedEventList).length > 0)">
      <todayHeader :marketType="market.tdyMarket.key" @updateMethod="showMarketMatches"></todayHeader>
      <template v-if="showhideAll">
        <template v-for="(eventObj, eventObjKey) in sortedEventList">
          <!-- League Capt -->
          <div class="list-card-wrap v-scroll-item relative-position sticky-wrap" :style="{'top':selectedMarket==market.tdyMarket.key ? '76.5px':'89.5px'}" style="height: 38px !important;">
            <div class="list-card-inner">
              <div class="c-match-league match-tpl2-bg"
                :class="{ 'match-tpl2': !showLgeEve[eventObjKey].hide, 'leagues-pack': showLgeEve[eventObjKey].hide }" @click="showLeg(eventObjKey, false)">
                <div class="tr-match-head">
                  <div class="leagues-wrap" :style="{ width:  widthColumn[2] + 'px !important' }">
                    <i size="14px" class="icon-arrow q-icon c-icon"></i>
                    <div class="league-icon-wrap">
                      <!-- <img data-team="undefined" data-csid="undefined" src="https://image.gredfged.com/group1/M00/18/2E/CgURtmOoQZGAH4WgAAAg5Xi2k74855.png" style="opacity: 1;"> -->
                    </div>
                    <div class="ellipsis-wrap">
                      <div class="absolute-full">
                        <span class="ellipsis allow-user-select" :title="eventObj[0].lgecapt" v-html="eventObj[0].lgecapt"></span>
                        <span class="league-match-count">{{ eventObj.length }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="play-name vrow col" v-show="!showLgeEve[eventObjKey].hide"> -->
                  <div class="play-name vrow col">
                    <template v-show="!showLgeEve[eventObjKey].hide">
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.H/H'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.H/D'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.H/A'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.D/H'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.D/D'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.D/A'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.A/H'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.A/D'] }}</div>
                      <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_4.A/A'] }}</div>
                    </template>
                  </div>
                  <div class="yb-flex-center" style="width: 42px !important;">
                    <div class="icon-wrap m-star-wrap-league"  @click="favouritelgeve(eventObj[0].lgeid, $event, '0', eventObj)">
                      <i class="icon-star q-icon c-icon"  :class="{ active: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- League Events -->
          <!-- <template v-if="!sortedEventList[eventObjKey].hide"> -->
          <template v-if="!showLgeEve[eventObjKey].hide">
            <template v-for="(event, eventKey) in eventObj">
              <div class="list-card-wrap v-scroll-item relative-position" style="height: 111px !important;">
                <div class="list-card-inner">
                  <div class="c-match-card relative-position" style="height: 111px !important">
                    <div class="c-match-item tpl-2 csid-1">
                      <div class="process-col yb-flex-center">
                        <sportTime :event="event"></sportTime>
                      </div>
                      <div class="match-handicap-item-wrap">
                        <div class="match-handicap-item">
                          <sportTeam :event="event" :issc="true" classes="none" :plyType="ftPlyType" :isRB="false"  :widthL=" widthColumn[0]"></sportTeam>
                          <div class="c-match-handicap" :id="'cmatch'+event.eveid">
                            <div class="vrow no-wrap">
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'hh'" :plyType="playtype" :betType="bettype" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'hd'" :plyType="playtype" :betType="bettype" :decimalNumber="0" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'ha'" :plyType="playtype" :betType="bettype" :decimalNumber="0" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'dh'" :plyType="playtype" :betType="bettype" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'dd'" :plyType="playtype" :betType="bettype" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'da'" :plyType="playtype" :betType="bettype" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'ah'" :plyType="playtype" :betType="bettype" :decimalNumber="0" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'ad'" :plyType="playtype" :betType="bettype" :decimalNumber="0" />
                                  </div>
                                </div>
                              </div>
                              <div class="handicap-col">
                                <div class="bet-item-wrap aosnoflex" style="height: 70px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                  <div
                                    class="c-bet-item yb-flex-center relative-position yb-family-odds no-handicap normal csid1 show-odds-icon" :class="'bet-htft-'+playtype">
                                    <div class="handicap-value">
                                      <span class="handicap-more" style="display: none;">&nbsp;</span>
                                      <div class="handicap-value-text"></div>
                                    </div>
                                    <cstgftht :event="event" :score="'aa'" :plyType="playtype" :betType="bettype" />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="score-more" style="width: 100%;">
                              <div class="mfo"></div>
                            </div>
                          </div>
                          <div class="media-col">
                            <div class="media-col-wrap">
                              <div class="icon-wrap after_tpl0 relative-position" :class="{ active: (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }">
                                <div class="v-icon switch-icon" @click="enterAllBet(event,1)" :class="{ active:  (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }" :title="sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']"></div>
                              </div>
                              <div class="yb-flex-center"></div>
                              <div data-v-5a29cfce="" class="icon-wrap relative-position" v-if="tvIconFlag && event.ch>0"> 
                                <div data-v-5a29cfce="" class="v-icon video-icon non-rb" :title="sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </template> <!-- END sortedEventList -->
      </template>
    </template>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
// import EventBus from '../../events/event-bus'
// import DateFilter from '@/vue/filters/date'
import cstgftht from '../../components/cs-tg-ftht'
import sportTime from './sportTimeColumn'
import sportTeam from './sportTeamColumn'
import todayHeader from './todayHeader'
import allBetMixin from '@/vue/mixins/allBet'
import sportFavourite from '@/vue/mixins/favourite'

export default {
  mixins: [allBetMixin, sportFavourite],
  components: {
    sportTime,
    sportTeam,
    todayHeader
  },
  computed: {
    ...mapGetters([
      'sportTableLang',
      'sortedEventList',
      'sortedRBEventList',
      'selectedMarket',
      'selectedBettype',
      'favouriteLgeEvents',
      'market', 
      'frameWidthHeight',
      'livetv',
      'firstEvent',
      'account',
      'showRBLgeEve',
      'showLgeEve',
      'tvIconFlag',
    ]),
    livetvEveid: {
      get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    firstEventEveid:{ 
      get() {
        let ft=this.$store.getters.firstEvent
        return Object.keys(ft).length>0 ? ft.eveid:0
      }
    },
    widthColumn: {
      get() {
        var fm = this.$store.getters.frameWidthHeight
        var pageCenter = fm.width.CenterPage_current;
        var betBoxWidthMin = 53;
        var betBoxWidthMax = fm.leagueTeam.betBoxWidthMax;
        var leagueBoxWidthMin = fm.leagueTeam.leagueBoxWidthMin;
        var league = leagueBoxWidthMin;
        var team = betBoxWidthMin;
        var timeColumn = fm.leagueTeam.timeColumn;
        var favColumn = fm.leagueTeam.favColumn;
        var columnCount =9;
        var AvailableLT = pageCenter-timeColumn-favColumn-(betBoxWidthMin*columnCount)-leagueBoxWidthMin;
        if(AvailableLT>0){
          let TeamCal = AvailableLT * 0.7;
          team=betBoxWidthMin+(TeamCal/columnCount);
          team= Math.floor(team);
          if(team<betBoxWidthMin){
            team=betBoxWidthMin
          }else if(team>betBoxWidthMax){
            team=betBoxWidthMax;
          }
          let caladd = team-betBoxWidthMin
          if(caladd>0){
            AvailableLT = AvailableLT -((team-betBoxWidthMin)*columnCount)
            if(AvailableLT>0){
              league = AvailableLT+leagueBoxWidthMin
            }
          }else{
            league = AvailableLT+leagueBoxWidthMin
          }
        }else{
          league = AvailableLT+leagueBoxWidthMin
        }
        league=league-15; // minus scroll width + border use
        return [league,team, league+timeColumn] // Team column , team column , league title
      },
    },
  },
  data() {
    return {
      reloading: false,
      playtype: '1',
      bettype: (this.$store.getters.selectedMarket == '3') ? allBetMixin.data().rhtftBetType : allBetMixin.data().htftBetType,
      rbbettype: allBetMixin.data().rhtftBetType,
      showhideAll: true,
      showRBhideAll: true,
    }
  },
  mounted: function () {
  },
  methods: {
    enterAllBet(event,startTv) {
      if(this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn){
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv=1;
      }
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: (event.rbstatus==1) ? true : false,
        token: token.arr_8,
        loadTemplate: startTv  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
      })
    },
    showMarketMatches(isRB) {
      if (isRB) {
        this.showRBhideAll = !this.showRBhideAll
      } else {
        this.showhideAll = !this.showhideAll
      }
    },
    showhideMain() {
      this.showhideAll = (this.showhideAll) ? false : true;
      var key = ''
      for (key in this.sortedEventList) {
        this.$set(this.sortedEventList[key], 'hide', !this.sortedEventList[key].hide)
      }
    },
    showLeg(key, isRB) {
      // this.$set(this.sortedEventList[key], 'hide', !this.sortedEventList[key].hide)

      if (!isRB) {
        this.$set(this.showLgeEve[key], 'hide', !this.showLgeEve[key].hide)
      } else if (isRB && !this.showFavEvents) {
        this.$set(this.showRBLgeEve[key], 'hide', !this.showRBLgeEve[key].hide)
      }
      if (this.showFavEvents && isRB) {
        this.$set(this.sortedFavRbEventList[key], 'hide', !this.sortedFavRbEventList[key].hide)
      }
    }
  },
  destroyed() {
    
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/soccerHTFT.vue